export default function(array, indexes) {
  var i = indexes.length, permutes = new Array(i);
  while (i--) permutes[i] = array[indexes[i]];
  return permutes;
}



//////////////////
// WEBPACK FOOTER
// ./packages/layout/node_modules/d3-array/src/permute.js
// module id = 277
// module chunks = 0